import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import Strings from "../../utils/stringUtil";
import AppIcons from "../../utils/appIcons";
import { isMobile } from "../../utils/responsiveUtil";
import styles from "../../assets/styles/main.module.css";
import FillButton from "../ui/fillButton";
import theme from "../../utils/themeUtil";
import Routes from "../../utils/routesUtil";

function Intro() {
    const handleClick = () => {
        window.open(Routes.MM_PLAY_STORE_URL, "_blank");
    };

    return (
        <React.Fragment>
            <Box className={styles.container}>
                <Grid container alignItems="center">
                    <Grid
                        item
                        xs={12}
                        md={6}
                        style={{ textAlign: isMobile ? "center" : "left" }}
                    >
                        <Box mt={isMobile ? 2 : 0}>
                            {isMobile && (
                                <img
                                    src={AppIcons.imgLadyBanner}
                                    alt="Lady Banner"
                                    style={{ width: "80%" }}
                                />
                            )}
                            <Typography
                                className="wow animate__animated animate__fadeInUp animate__delay-0s"
                                style={{
                                    fontSize: isMobile ? "30px" : "36px",
                                    fontWeight: "600",
                                }}
                            >
                                {Strings.financialPlatformForWomenHeader}
                            </Typography>
                            <Box mt={3}>
                                <Typography
                                    className="wow animate__animated animate__fadeInUp animate__delay-0.s"
                                    style={{
                                        fontSize: isMobile ? "14px" : "18px",
                                        fontWeight: "400",
                                    }}
                                >
                                    {Strings.financialPlatformForWomenSubHeader}
                                </Typography>
                            </Box>
                            <Box className="wow animate__animated animate__fadeInUp animate__delay-0.7s" mt={isMobile ? 2 : 6}>
                                <FillButton
                                    backgroundColor={theme.palette.black.main}
                                    textColor="#ffffff"
                                    text={Strings.downloadApp}
                                    cornerRadius="8px"
                                    fontSize="14px"
                                    onClick={handleClick}
                                />
                            </Box>
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={6} style={{ textAlign: "center" }}>
                        {!isMobile && (
                            <img
                                src={AppIcons.imgLadyBanner}
                                alt="Lady Banner"
                                style={{ width: "80%" }}
                            />
                        )}
                    </Grid>
                </Grid>
            </Box>
            <img
                src={AppIcons.imgHomeIntroBg}
                alt="BG"
                style={{ width: "100%", height: "50px" }}
            />
        </React.Fragment>
    );
}

export default Intro;
